// Decline reason types and options for custom quote requests

import { object, string } from "yup";

export interface DeclineReason {
	value: string;
	label: string;
	description: string;
}

export const DECLINE_REASONS: DeclineReason[] = [
	{
		value: "vendor_limitations",
		label: "Vendor Limitations",
		description: "Outside vendor offerings and what they can produce"
	},
	{
		value: "unable_to_manufacture",
		label: "Unable to Manufacture",
		description: "Out of our current product range and capability"
	},
	{
		value: "information_unclear",
		label: "Information Provided is Unclear",
		description: "Designer must provide more detailed information needed to process."
	},
	{
		value: "missing_valid_information",
		label: "Missing Valid Information",
		description: "Designer must provide correct manufacturer specs."
	},
	{
		value: "ocm_information_missing",
		label: "OCM Information Missing",
		description:
			"Designer has to provide the oven cutout information they want. Quotes team will not research to apply without designer confirmation."
	},
	{
		value: "standard_cabinet_available",
		label: "Standard Cabinet is Available",
		description: "Does not require a custom quote. Can be processed by sku and mods noted."
	}
];

export type DeclineReasonValue = (typeof DECLINE_REASONS)[number]["value"];

// Form data interface
export interface DeclineRequestFormData {
	declineReason: DeclineReasonValue;
	message: string;
}

// Form validation schema
export const declineRequestFormSchema = object({
	declineReason: string()
		.required("Please select a reason for declining")
		.oneOf(
			DECLINE_REASONS.map((reason) => reason.value),
			"Invalid decline reason selected"
		),
	message: string()
		.required("Please provide a message to the designer")
		.min(10, "Message must be at least 10 characters")
		.max(1000, "Message cannot exceed 1000 characters")
});
